import { useMetaTrackHook } from '@/hooks/useMetaTrackHook';
import { useSacola } from '@/hooks/useSacola';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';

interface ResumoCompraValores {
  quantidadeProdutos: number;
  valorTotal: number;
}

export function informarValoresResumoCompra(valores: ResumoCompraValores) {
  return sessionStorage.setItem(
    'chippuPlace@ResumoCompra',
    JSON.stringify(valores),
  );
}

export function removerValoresResumoCompra() {
  return sessionStorage.removeItem('chippuPlace@ResumoCompra');
}

export default function useResumoCompraHook() {
  const router = useRouter();

  const {
    itens,
    recuperandoValoresSacola,
    usuarioAceitouOsTermos,
    informarUsuarioAceitouTermos,
    formatarFormaPagamento,
  } = useSacola();

  const [valoresResumoCompra, setValoresResumoCompra] =
    useState<ResumoCompraValores | null>(null);

  const { recuperarMetaTrackSessionStorage } = useMetaTrackHook();

  const [usuarioVeioLandingPage, setUsuarioVeioLandingPage] = useState(false);

  const { status } = useSession();

  async function recuperarValoresSessionStorage() {
    const valoresResumoCompraSessionStorage = sessionStorage.getItem(
      'chippuPlace@ResumoCompra',
    );

    if (valoresResumoCompraSessionStorage) {
      const valoresResumoCompraConvertido: ResumoCompraValores = JSON.parse(
        valoresResumoCompraSessionStorage,
      );
      setValoresResumoCompra(valoresResumoCompraConvertido);
    }

    const metaTrackParametersParsed = recuperarMetaTrackSessionStorage();
    if (metaTrackParametersParsed) setUsuarioVeioLandingPage(true);
  }

  useEffect(() => {
    recuperarValoresSessionStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mostrarCheckboxDosTermosDaAssinatura = useMemo(() => {
    return itens?.some(
      (item) =>
        item.opcaoSelecionadaProduto?.tipo === 3 &&
        (item.produto?.termosDeUso || '').trim()?.length > 2,
    );
  }, [itens]);

  const mostrarCheckboxDosTermosGiftCards = useMemo(() => {
    return itens?.some((item) => {
      return item.opcaoSelecionadaProduto?.tipo == 1;
    });
  }, [itens]);

  useEffect(() => {
    if (
      mostrarCheckboxDosTermosDaAssinatura ||
      mostrarCheckboxDosTermosGiftCards
    ) {
      informarUsuarioAceitouTermos(false);
    } else {
      informarUsuarioAceitouTermos(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mostrarCheckboxDosTermosGiftCards, mostrarCheckboxDosTermosDaAssinatura]);

  const telaCaminhoBotaoContinuarPagamento = useMemo(() => {
    if (usuarioVeioLandingPage && status === 'unauthenticated') {
      return '/compra-rapida';
    }
    // return '/validar-sms';
    return '/forma-pagamento';
  }, [usuarioVeioLandingPage, status]);

  return {
    valoresResumoCompra,
    router,
    usuarioAceitouOsTermos,
    informarUsuarioAceitouTermos,
    itens,
    recuperandoValoresSacola,
    mostrarCheckboxDosTermosDaAssinatura,
    formatarFormaPagamento,
    usuarioVeioLandingPage,
    telaCaminhoBotaoContinuarPagamento,
    mostrarCheckboxDosTermosGiftCards,
  };
}
